module.exports = __webpack_public_path__ + "img/icon-alarm.4184021d.svg";